import { isTag } from 'anodum';
import instance from '../../instance';

const pickUpIframe = (element) => {
  const { children } = element;
  for (let i = 0, l = children.length; i < l; i += 1) {
    const node = children[i];
    if (
      (isTag(node, 'iframe') || isTag(node, 'ws-iframe')) &&
      instance.driver.referenceMap.hasReference(node)
    ) {
      return node;
    }
  }
  return null;
};

export default pickUpIframe;
